export default {
  default: {
    accecss: 'Access',
    access_protocol: 'Access Protocol',
    account: 'Account',
    account_data: 'Account data',
    account_type: 'Account type',
    accumulated_debt: 'Accumulated debt',
    acs: 'ACS',
    acs_disabled: 'ACS disabled',
    acs_enabled: 'ACS enabled',
    action: 'Action',
    actions: 'Actions',
    activate: 'Activate',
    active: 'Active',
    active_discounts: 'Active',
    active_order: 'Active order',
    active_recurring_items: 'Active recurring items',
    add: 'Add',
    add_column: 'Add column',
    add_column_left: 'Add column to the left',
    add_column_right: 'Add column to the right',
    add_credit_card: 'Add credit card',
    add_dgo: 'Add DGO',
    add_discount: 'Add discount',
    add_filter: 'Add Filter',
    add_forward: 'Add forwarded port',
    add_forwarded_ports: 'Add forwarded ports',
    add_item: 'Add item',
    add_nested_filter: 'Add nested filter',
    add_new_field: 'Add new field',
    add_recurring_item: 'Add recurring item',
    add_recurring_item_tax: 'Add tax',
    add_row: 'Add row',
    add_row_above: 'Add row above',
    add_row_below: 'Add row below',
    add_seal: 'Add seal',
    add_service: 'Add service',
    add_tax: 'Add tax',
    additional_data: 'Additional data',
    address: 'Address',
    address_ip: 'IP Address',
    addresses: 'Addresses',
    admin: 'Admin',
    administrative: 'Administrative',
    administrative_read_only: 'Read only Administrative',
    administrative_supervisor: 'Administrative supervisor',
    administrative_supervisor_read_only: 'Read only Administrative supervisor',
    advanced: 'Advanced',
    advanced_search: 'Advanced search',
    advanced_search_description_tour:
      'Create complex queries in seconds with our enhanced filter panel. Combine multiple fields and operators to find exactly what you need.',
    agreement_details: 'Agreement details',
    alert_internet: 'Internet Alert',
    alerted: 'Alerted',
    alerts: 'Alerts',
    all: 'All',
    all_invalid_mobile_phones: 'All invalid mobile phones',
    all_periods: 'All periods',
    all_the: 'all the',
    allow_blank: 'Cannot be Empty',
    allow_nil: 'Cannot be Empty',
    allowed_formats: 'Allowed formats',
    amount: 'Amount',
    amount_gteq: 'Amount (From)',
    amount_iva: 'Amount IVA',
    amount_lteq: 'Amount (To)',
    amount_with_igv: 'Amount with IGV',
    amount_with_vat: 'Amount with VAT',
    amount_without_iva: 'Amount without IVA',
    amplitude: 'Amplitude',
    api: 'API',
    api_credentials: 'API Credentials',
    api_key: 'API Key',
    api_login: 'API Login',
    api_response: 'API Response',
    api_ssl_port: 'API-SSL Port',
    api_token: 'API Token',
    app_mobile: 'App Mobile',
    applied: 'Applied',
    applied_at: 'Applied at',
    applied_lapses: 'Applied lapses',
    apply: 'Apply',
    apply_discount: 'Apply discount',
    applying: 'Applying',
    article: 'Article',
    articles: 'Articles',
    assign: 'Assign',
    assignable_to: 'Assigned to',
    assigned_type: 'Assigned type',
    assistance: 'Assistance',
    associated_contracts: 'Associated contracts',
    attachment: 'Attachment',
    attachment_not_loaded: 'Failed to load attachment file.',
    attempts: 'Attempts',
    attention: 'Attention',
    audit: 'Audit',
    audits: 'Audits',
    authorize: 'Authorize',
    authorize_invoice_after_paid: 'Inform after paid',
    authorize_ont: 'Authorize ONT',
    authorized: 'Authorized',
    authorizing: 'Autorizing',
    auto_confirm: 'Confirm automatic',
    autocomplete_first_free_ip: 'Autocomplete first free IP',
    automatic: 'Automatic',
    automatic_debit: 'Automatic debit',
    automatic_state: 'Automatic state',
    availability: 'Availability',
    available_credit: 'Available credit',
    available_credit_in_account: 'Available credit in account',
    available_one: 'Available',
    available_other: 'Available',
    available_ports: 'Available ports',
    available_promises: 'Available promises',
    avatar: 'Avatar',
    back: ' Back',
    backups: 'Backups',
    balance: 'Balance',
    band_2_4_disconnected: 'Band (2.4Ghz) disconnected',
    band_5_disconnected: 'Band (5.8Ghz) disconnected',
    bank: 'Bank',
    bank_process_date: 'Bank process date',
    bank_transfer: 'bank transfer',
    barcode: 'Barcode',
    base: 'Base',
    base_errors_title: 'Please review the problems below:',
    basic: 'Basic',
    batch: 'Batch',
    billing_information: 'Billing information',
    billing_regime: 'Billing Regime',
    bmu: 'BMU',
    bmu_id: 'BMU (ID)',
    board: 'Board',
    body: 'Body',
    both: 'Both',
    box_details: 'Box details',
    branch_office: 'Branch office',
    brand: 'Brand',
    broadcast: 'Broadcast',
    burst: 'Burst',
    by_default: 'Default',
    cable_modem: 'Cable Modem',
    cable_modem_bin_file: 'Cable modem bin file',
    cable_modem_enabled: 'Cable modem enabled',
    cable_modem_gateway: 'Cable modem gateway',
    cable_modem_ip: 'Cable modem ip',
    cable_modem_mac_address: 'Cable modem mac address',
    cache: 'Cache',
    calendar: 'Calendar',
    cancel: 'Cancel',
    cancel_selection: 'cancel selection',
    canceled: 'Canceled',
    cancelled_amount: 'Cancelled amount',
    cancelled_at: 'Cancelled at',
    cancelled_invoice: 'Cancelled invoice',
    cancelled_payment: 'Cancelled payment',
    cant_change_server_if_exist_forwarded_ports: 'Cant change server if exist forwarded ports',
    cant_change_server_if_exist_full_nat: 'Cant change server if exist FULL-NAT',
    cant_connect_to_mikrotik: 'Cant connect to mikrotik',
    capacity: 'Capacity',
    cardnet: 'Cardnet',
    cash: 'Cash',
    cash_audit_id: 'Cash Audit (ID)',
    categories: 'Categories',
    category: 'Category',
    cbu_holder: 'Account holder CBU',
    ceil_dfl_percent: 'Ceil DFL percentage',
    certificate_updated: 'Certificate updated',
    change_password: 'Change password',
    change_ssid: 'Change SSID',
    change_state: 'Change state',
    change_user: 'Change user',
    chars_quantity: 'Characters quantity',
    check: 'Check',
    check_service: 'Check service',
    choose_a_kind_of_person: 'Choose a kind of person',
    choose_a_nap_on_the_map: 'Choose a NAP on the map',
    choose_a_regimen: 'Choose a regimen',
    choose_an_invoicing_firm: 'Choose an invoicing firm',
    choose_an_invoicing_firm_and_a_kind_invoice: 'Choose an invoicing firm and a kind invoice',
    choose_an_invoicing_firm_and_a_kind_person: 'Choose an invoicing firm and a kind person',
    choose_an_option: 'Choose an option',
    choose_substitutions: 'Choose substitutions',
    choose_to_invoicing_firm: 'Choose to invoicing firm',
    cir: 'CIR',
    city: 'City',
    clean_errors: 'Clean Errors',
    clean_filters: 'Clean Filters',
    clear_search: 'Clear search',
    clear_selection: 'Clear selection.',
    click: 'click here',
    client: 'Client',
    client_bank: 'Client bank',
    client_bank_name: 'Client bank name',
    client_email: 'Client email',
    client_id: 'Client (ID)',
    client_identification: 'Client identification',
    client_identification_number: 'Client identification number',
    client_info: 'Client Info',
    client_invoicing_disabled: 'Client has invoicing disabled',
    client_name: 'Client name',
    client_not_found: 'Client not found',
    client_phone: 'Client phone',
    client_phone_number: 'Client phone number',
    client_reference: 'Client reference',
    client_secret: 'Secret password',
    clients: 'Clients',
    clients_with_errors: 'Clients with errors',
    clients_with_processed: 'Valid clients',
    close: 'Close',
    close_issue: 'Close Issue',
    close_massive_update: 'Close massive update',
    close_preview: 'Close preview',
    closed: 'Closed',
    closed_at: 'Closed at',
    cobro_digital: 'Cobro Digital',
    code: 'Code',
    collections: 'Collections',
    collector: 'Collector',
    collector_email: 'Collector email',
    collector_id: 'Collector (ID)',
    collector_read_only: 'Read only Collector',
    color: 'Color',
    combo_pay: 'Combopay',
    command: 'Command',
    comment: 'Comment',
    comments: 'Comments',
    common_regime: 'Common Regime',
    company_id: 'Company (ID)',
    company_name: 'Company Name',
    complete_nap: 'Complete NAP',
    completed: 'Completed',
    complexity: 'Complexity',
    concept: 'Concept',
    config_by_wispro: 'Config by Wispro',
    configuration: 'Configuration',
    configurations: 'Configurations',
    configure: 'Configure',
    configure_notifications: 'Configure notifications',
    confirm: 'Confirm',
    connected: 'Connected',
    connection_with_wispro: 'Connection with Wispro',
    connectivity: 'Connectivity',
    consumption_summary: 'Consumption summary',
    contact: 'Contact',
    contact_information: 'Contact information',
    contact_name: 'Contact name',
    contact_with_support: 'Contact with support',
    contract: 'Contract',
    contract_id: 'Contract (ID)',
    contract_identifier: 'Contract N°',
    contracts: 'Contracts',
    contracts_affected: 'Contracts affected',
    contracts_limit_almost_reached: 'The subscription max contracts is almost reached.',
    contracts_limit_reached: 'The subscription max contracts is reached, please update your subscription.',
    contracts_linked: 'Contracts linked',
    contracts_to_apply: 'Contracts to apply',
    converter: 'Converter',
    copied: 'Copied',
    // FIXME PENDIENTE REORDENAR Y BORRAR DUPLICADOS
    copied_succesfully: 'Copied succesfully',
    copy: 'Copy',
    copy_token: 'Copy TOKEN',
    corporative: 'Corporative',
    cost: 'Cost',
    could_not_be_sent: 'Could not be sent',
    count_applied_lapse: 'Applied periods',
    country: 'Country',
    coverage: 'Coverage',
    coverage_id: 'Wireless Node',
    cpe_port: 'CPE Port',
    cpe_protocol: 'CPE Protocol',
    create: 'Create',
    create_categories: 'Create categories',
    create_changelog: 'Create Changelog',
    create_configuration: 'Create Configuration',
    create_neighborhood: 'Create neighborhood',
    create_new: 'Create new',
    create_new_client: 'Create new Client',
    create_new_profile: 'Create new profile',
    create_notification_mobile: 'Create Notification mobile',
    create_olt: 'Create OLTs',
    create_payment_promise: 'Create Payment promise',
    create_port_forward: 'Create forwarded port',
    create_ppp_profile: 'Create PPP profile',
    create_ticket: 'Create Ticket',
    create_ticket_and_order: 'Create Ticket and Order',
    create_ticket_and_order_feasibility: 'Create Ticket and Feasibility',
    create_ticket_and_order_installation: 'Create Ticket and Installation',
    create_zone: 'Create zone',
    created: 'Created',
    created_at: 'Created at',
    created_at_between: 'Created at between (Dates)',
    created_at_gteq: 'Created (From)',
    created_at_lteq: 'Created (To)',
    created_by: 'Created by',
    created_date: 'Created date',
    creation: 'Creation',
    creator: 'Creator',
    credentials: 'Credentials',
    credit: 'Credit',
    credit_card: 'Credit card',
    credit_note: 'Credit note',
    credit_note_create: 'Credit note create',
    credit_note_edit: 'Credit note edit',
    credit_notes: 'Credit Notes',
    criteria: 'Criteria',
    critical: 'Critical',
    critical_interfaces: 'Critical interfaces',
    critical_ports: 'Critical ports',
    csv_file: 'CSV File',
    cuenta_digital: 'Cuenta Digital',
    cuit_holder: 'Account holder CUIT',
    current_account: 'Current account',
    current_amount_with_igv: 'Current amount with IGV',
    current_amount_with_vat: 'Current amount with VAT',
    current_credit_note_number_voucher: 'Last credit note num. nota Voucher',
    current_discount: 'Current discount',
    current_discount_scale: 'Current discount scale',
    current_discounts: 'Current discounts',
    current_file_number: 'Unique ascending sequential number per file',
    current_invoice_number_voucher: 'Last invoice num. Voucher',
    current_revenue_share: 'Current revenue share',
    custom_id: 'Custom ID',
    custom_netmask: 'Netmask',
    custom_payment: 'Custom payment',
    customizable_client_id: 'Customizable Client ID',
    //Estas keys se crearon para rails provisoriamente
    customizable_identifier: 'Customizable identifier',
    customizeNews: "Customize what's new",
    cycle: 'Cycle',
    data: 'Data',
    date: 'Date',
    date_processed: 'Date processed',
    day: 'day',
    days: 'days',
    days_of_service: 'Days of service',
    deactivate: 'Deactivate',
    debit: 'debit',
    debit_card: 'Debit card',
    degraded: 'Degraded',
    delete: 'Delete',
    delete_all: 'Delete all',
    delete_column: 'Delete column',
    delete_discount: 'Delete discount',
    delete_record: 'Delete record',
    delete_records: 'Delete records',
    delete_recurring_item: 'Delete recurring item',
    delete_row: 'Delete row',
    delete_service: 'Delete service',
    delete_tax: 'Delete tax',
    deleted: 'Deleted',
    deleted_at: 'Deleted at',
    deleted_payment: 'Payment deleted',
    deleting: 'Deleting',
    delimiter: 'Delimiter',
    delinquent: 'Delinquent',
    description: 'Description',
    deselect_all: 'Deselect all',
    destination_number: 'Destination Number',
    destroy: 'Destroy',
    detail: 'Detail',
    details: 'Details',
    device: 'Device',
    device_id: 'Device (ID)',
    device_name: 'Device Name',
    device_signal: 'Device signal',
    devices: 'Devices',
    dgo: 'DGO',
    dgo_pack: 'DGO Pack',
    dhcp: 'DHCP',
    dhcp_enabled: 'Dhcp enabled',
    dhcp_mac_address: 'DHCP Relay MAC Address',
    dhcp_server: 'DHCP Server',
    dhcpv6_pd_pool: 'DHCPv6 PD Pool',
    disable: 'Disable',
    disable_automatic_sending: 'Disable automatic sending',
    disabled: 'Disabled',
    disabled_contract: 'Disabled contract',
    disabling: 'Disable',
    discharge_date: 'Discharge date',
    disconnected: 'Disconnected',
    discount: 'Discount',
    discount_amount: 'Discount amount',
    discount_applied: 'Applied discount',
    discount_management: 'Discount management',
    discount_percentage: 'Discount (%)',
    discounts: 'Discounts',
    disocunt_scale: 'Discount scale',
    dns: 'DNS',
    dns_one: 'First DNS',
    dns_servers: 'DNS Servers',
    dns_two: 'Second DNS',
    documents: 'Documents',
    domain: 'Domain',
    done: 'Done',
    download: 'Download',
    download_afip_certificate: 'Download order form to request certificate',
    download_count_rows_one: 'Download {{count}} row',
    download_count_rows_other: 'Download {{count}} rows',
    download_csv: 'Download CSV',
    download_dataset: 'Download dataset',
    download_invoice: 'Download invoice',
    download_successful: 'Download successful',
    download_xls: 'Download Excel',
    draft: 'Draft',
    drag_and_drop_files_or_click: 'Drag and drop files, or click to select',
    drag_elements_here: 'Drag elements here',
    drop_files_here: 'Drop files here',
    due_date: 'Due date',
    due_dates: 'Due Dates',
    duplicate_column: 'Duplicate column',
    edit: 'Edit',
    edit_isp: 'Edit ISP',
    edit_massive_update: 'Edit massive update',
    edition: 'Edition',
    edition_data: 'Edition data',
    efecty: 'Efecty',
    electronic: 'Electronic',
    electronic_enabled: 'Electronic enabled',
    electronic_invoice: 'Electronic invoice',
    electronic_invoicing_firm_unvalidated: 'Unverified electronic invoicing firm',
    electronic_invoicing_firm_validated: 'Electronic Invoicing Firm validated',
    electronic_payment_code: 'Electronic payment code',
    electronic_transfer: 'Electronic transfer',
    electronic_validated: 'Electronic account validated',
    electronic_verify: 'Electronic verify',
    email: 'Email',
    emails_to_notify: 'Emails to notify',
    empty_label: 'No match',
    empty_list: 'Empty List',
    emptystring: '',
    enable_automatic_sending: 'Enable automatic sending',
    enabled: 'Enabled',
    enabling: 'Enable',
    encoding: 'Encoding',
    english: 'English',
    enter_address: 'Enter Address',
    erasable: 'Erasable',
    error: 'Error',
    error_generate_authorization_invoices: 'There was an error generating the dataset',
    error_type: 'Error type',
    errors: 'Errors',
    event: 'Event',
    example: 'Example',
    exclude: 'Exclude',
    expiration_date: 'Expiration date',
    expire: 'Expire',
    expire_at: 'Expire at',
    expired: 'Expired',
    expires_at: 'Expires at',
    export: 'Export',
    export_all: 'Export all',
    export_cash_audits: 'Export Cash Audits',
    export_classic: 'Export Contracts with Classic structure',
    export_classic_entry: 'Export Classic',
    export_clients: 'Export Clients',
    export_contracts: 'Export Contracts',
    export_contracts_with_price: 'Export Contracts with price',
    export_credit_notes: 'Export Credit Notes',
    export_csv: 'Export to CSV',
    export_installation_orders: 'Export Installation Orders',
    export_invalid_mobile_phone_numbers: 'Export invalid mobile phone numbers',
    export_invoices: 'Export Invoices',
    export_olts: 'Export OLTs',
    export_only_filtered: 'Export only filtered',
    export_payments: 'Export Payments',
    export_png: 'Export a PNG',
    export_xls: 'Export to Excel',
    exporter: 'Exporter',
    exporting: 'Exporting',
    exports: 'Exports',
    external_technician: 'External Technician',
    extra_vlans: 'Extra VLANS',
    extras: 'Extras',
    facilito: 'Facilito',
    failed_at: 'Failed at',
    failure: 'Failure',
    fantasy: 'Fantasy',
    fbp: 'FBP',
    feature_preview: 'Feature preview',
    feedback: 'Feedback',
    feedback_id: 'Feedback ID',
    feedback_kind: 'Feedback kind',
    feedback_kinds: 'Feedback kinds',
    feedbacks: 'Feedbacks',
    file_for_import: 'File for import',
    filter: 'Filter',
    filter_in_table: 'Filter in table',
    filter_name: 'Filter name',
    filter_search: 'Filter Search',
    filtered_records: 'Filtered records',
    filtering: 'Filtering',
    filters: 'Filters',
    final_price: 'Final Price',
    finalized: 'Finalized',
    finalized_at: 'Finalized at',
    finalized_issue: 'Finalized issue',
    find_transactions: 'Find transactions',
    finished_discounts: 'Finished',
    firmware_model: 'Firmware Model',
    first: 'First',
    first_last_name: 'First last name',
    //Estas keys se crearon para rails provisoriamente
    first_name: 'First name',
    first_number: 'First number',
    fiscal_info: 'Fiscal Info',
    fixed_amount: 'Fixed amount',
    forwarded_ports: 'Forwarded ports',
    frame: 'Frame',
    frecuency: 'Frecuency',
    from: 'from',
    full_nat: 'FULL-NAT',
    gateway: 'Gateway',
    general: 'General',
    general_info: 'General Info',
    general_information: 'General information',
    general_manager: 'General manager',
    general_manager_read_only: 'Read only General manager',
    generate_invoice_every_day: 'Generate invoice every day',
    generate_transaction: 'Generate transaction',
    generic: 'Generic',
    geolocation: 'Geolocation',
    go_to: 'go to',
    go_to_basic_search: 'Go to Basic Search',
    go_to_documentation: 'Go to documentation',
    go_to_googlemaps: 'Go to Google Maps',
    go_to_license: 'Go to License',
    go_to_olt: 'Go to OLT',
    go_to_the_documentation: 'Go to the documentation',
    greater_than: 'Greater than',
    greater_than_or_equal_to: 'Greater than or equal to',
    gross_amount: 'Gross Amount',
    gross_income: 'Gross Income',
    has_active_filters: 'Has active filters',
    hashtag: '#',
    have_selected: 'Have selected',
    helpdesk: 'Helpdesk',
    helpdesk_read_only: 'Read only Helpdesk',
    helpdesk_supervisor: 'Helpdesk supervisor',
    helpdesk_supervisor_read_only: 'Read only Helpdesk supervisor',
    here: 'here',
    hide: 'Hide',
    hide_details: 'Hide Details',
    high: 'High',
    home: 'Home',
    hour: 'Hour',
    hours: 'Hours',
    how_to_use_composal_download: 'How to use the download',
    how_to_use_it: 'How to use it',
    how_to_use_massive_update: 'How to use the massive update',
    id: 'ID',
    identifiers: 'Identifiers',
    image: 'Image',
    images: 'Images',
    import: 'Import',
    import_aliases_cbu: 'Import Alias/CBU (Siro)',
    import_payments: 'Import payments',
    import_statuses: 'Import Statuses',
    importer: 'Importer',
    in_use: 'In use',
    inactive: 'Inactive',
    inactive_recurring_items: 'Inactive recurring items',
    include: 'Include',
    include_all_periods: 'Include all periods',
    included_in: 'Included in',
    indicators: 'Indicators',
    informing: 'Informing',
    instagram_quantity: 'Instagram quantity',
    installation: 'Installation',
    installation_orders: 'Installation orders',
    installation_price: 'Installation price',
    installer: 'Installer',
    installer_read_only: 'Read only Installer',
    installer_supervisor: 'Installer supervisor',
    installer_supervisor_read_only: 'Read only Installer supervisor',
    interest: 'Interest',
    interests: 'Interests',
    interface: 'Interface',
    interface_not_belongs_to_server: "The interface doesn't belongs to the contract server",
    interfaces: 'Interfaces',
    invalid_merchant_abrev: 'Invalid Merchant abrev',
    invalid_token: 'Invalid token',
    inventory_articles: 'Inventory articles',
    invoice: 'Invoice',
    invoice_create: 'Invoice create',
    invoice_details: 'Invoice details',
    invoice_edit: 'Invoice edit',
    invoice_from: 'Invoice from',
    invoice_number: 'Invoice number',
    invoice_payments: 'Invoice Payments',
    invoice_provider: 'Invoice Provider',
    invoice_title: '{{kind_invoice}} from {{firm_company_name}} ({{firm_vat_condition}})',
    invoiced: 'Invoiced',
    invoiced_at: 'Invoiced At',
    invoices: 'Invoices',
    invoicing: 'Invoicing',
    invoicing_client: 'Invoicing client',
    invoicing_client_id: 'Client (Invoicing ID)',
    invoicing_contract_id: 'Contract (Invoicing ID)',
    invoicing_disabled: 'Invoicing disabled',
    invoicing_discount_id: 'Discount',
    invoicing_enabled: 'invoicing_enabled',
    invoicing_errors: 'Invoicing errors',
    invoicing_firm: 'Invoicing Firm',
    invoicing_firm_id: 'Invoicing firm (ID)',
    invoicing_firms: 'Invoicing Firms',
    invoicing_info: 'Invoicing Info',
    invoicing_information: 'Invoicing information',
    invoicing_invoice: 'Invoice',
    invoicing_isp_id: 'ISP (Invoicing ID)',
    invoicing_module: 'Invoicing Module',
    invoicing_name: 'Invoicing name',
    invoicing_payment: 'Payment',
    invoicing_plan_attributes: {
      frecuency: 'Frecuency',
      price: 'Price',
      product_code: 'Product Code'
    },
    invoicing_profile: 'Invoicing profile',
    invoicing_profile_id: 'Invoicing Profile',
    invoicing_state: 'Invoicing state',
    invoicing_summary: 'Invoicing summary',
    ip: 'IP',
    ip_address: 'IP Address',
    ip_mode: 'IP Mode',
    isp: 'ISP',
    isp_id: 'ISP (ID)',
    isp_name: 'ISP name',
    issue: 'Issue',
    issue_invoice: 'Issue invoice',
    issued_at: 'Issued at',
    issued_at_date: 'Issue date',
    issues: 'Issues',
    item: 'Item',
    item_taxes: 'Taxes',
    items: 'Items',
    kind: 'Kind',
    kind_invoice: 'Invoice type',
    kind_person: 'Kind person',
    kind_subscription: 'Kind subscription',
    language: 'Language',
    lapses: 'Lapses',
    last: 'Last',
    last_4_digits: 'Last 4 digits',
    last_digits: 'last {{count}} digits',
    last_name: 'Last name',
    last_number: 'Last number',
    last_payments: 'Last payments',
    last_transaction: 'Last transaction',
    last_update: 'Last update',
    last_used_number: 'Last used number',
    latitude: 'Latitude',
    layout: 'Layout',
    lead: 'Lead',
    lead_info: 'Lead information',
    lead_name: 'Lead name',
    less_than: 'Less than',
    less_than_or_equal_to: 'Less than or equal to',
    level: 'Level',
    license: 'License',
    limits: 'Limits',
    link: 'Link',
    link_ont: 'Link',
    link_payments: 'Link payments',
    link_with_ont: 'Link with ONT',
    linked: 'Linked',
    linked_contracts: 'Linked contracts',
    linked_female: 'Linked',
    linked_male: 'Linked',
    load_again: 'Reload',
    loading: 'Loading',
    loading_new_info: 'Loading new info',
    //same as reload but changes the spanish translation
    local_address: 'Local Address',
    locality: 'Locality',
    location: 'Location',
    location_data: 'Location data',
    location_id: 'Location ID',
    location_type: 'Location type',
    locations: 'Locations',
    locked_at: 'Locked at',
    longitude: 'Longitude',
    low: 'Low',
    mac_address: 'MAC Address',
    mac_address_relay: 'MAC Address Relay',
    major: 'Major',
    manual: 'Manual',
    manual_notifications: 'Manual Notifications',
    manual_payments_import: 'Manual payments import',
    manuals: 'Manuals',
    map: 'Map',
    mark_as_viewed: 'Mark as viewed',
    massive_actions: 'Massive actions',
    massive_destroy: 'Massive delete',
    massive_update: {
      massively_update: 'Massively update',
      mikrotik_interface_id: 'Mikrotik interface (ID)',
      plan_id: 'Plan (ID)'
    },
    massive_update_confirm: 'Confirm Massive update',
    max_download: 'Max Download',
    max_upload: 'Max Upload',
    medium: 'Medium',
    mercado_pago: 'Mercado Pago',
    messenger_quantity: 'Messenger quantity',
    metrics: 'Metrics',
    mi_vecino: 'Mi vecino',
    migrator: 'Migrator',
    mikropipi: 'Mikropipi',
    mikrotik: 'Mikrotik',
    mikrotik_configuration: 'Mikrotik Configuration',
    mikrotik_interface_id: 'Mikrotik interface',
    mikrotik_not_linked: 'Mikrotik not  linked',
    mikrotik_use_ssl: 'API-SSL',
    minor: 'Minor',
    minute: 'minute',
    minutes: 'minutes',
    missing_key: 'Missing key',
    missing_substitution: 'Missing substitutions',
    mobile: 'Mobile',
    mobile_phone: 'Mobile phone',
    //Estas keys se crearon para rails provisoriamente
    mobile_phone_number: 'Mobile phone number',
    mode: 'Mode',
    model: 'Model',
    models: '{{models}}',
    module: 'Module',
    month: 'month',
    months: 'months',
    more_actions: 'More actions',
    more_info: 'More info',
    multiple_clients_by_reference: 'Multiple references',
    name: 'Name',
    nap: 'NAP',
    nap_id: 'NAP (ID)',
    nap_map: 'Nap map',
    nap_port: 'NAP Port',
    naps: 'NAPs',
    nas: 'NAS',
    nas_disabled: 'NAS disabled',
    nas_enabled: 'NAS enabled',
    national_identification_number: 'National identification number',
    neighborhood: 'Neighborhood',
    neighborhood_id: 'Neighborhood (ID)',
    neighborhoods: 'Neighborhoods',
    nested_filters: 'Nested filters',
    net_amount: 'Net Amount',
    netmask: 'Netmask',
    network: 'Network',
    new: 'New',
    new_password: 'New password',
    new_payment: 'New Payment',
    new_ssid: 'New SSID',
    news: 'News',
    next: 'Next',
    next_amount: 'Next amount with VAT',
    next_amount_with_igv: 'Next amount with IGV',
    next_discount: 'Next discount',
    next_discount_scale: 'Next discount scale',
    next_invoices: 'Next invoices',
    next_periods: 'Next periods',
    next_revenue_share: 'Next revenue share',
    no: 'No',
    no_active_order: 'Sin orden activa',
    no_audits: 'No audits',
    no_details: 'No details',
    no_device_notifications: 'No device notifications',
    no_devices: 'No devices',
    no_errors_found: 'No errors found',
    no_geolocation: 'No Geolocation',
    no_linked: 'No linked',
    no_matches_found: 'No matches found',
    no_more_discount: 'No more discount',
    no_options: 'No options',
    no_payment_gateways: 'No payment gateways',
    no_pg_verified: 'No payment gateways verified',
    no_port_forwarding: 'No port forwarding',
    no_published_at: 'No publication date',
    no_records: 'No records',
    no_results_found: 'No results found',
    no_rows_to_process: 'No rows to process',
    no_transactions: 'No transactions',
    no_verified_payment_gateways: 'No verified payment gateways',
    node: 'Node',
    node_id: 'Node (ID)',
    nodes: 'Nodes',
    not_associated_with_any_nap_box: 'It is not associated with any NAP box',
    not_be_invoiced: 'Not be invoiced',
    not_dispatched: 'Not dispatched',
    not_linked: 'Not Linked',
    not_linked_female: 'Not Linked',
    not_linked_male: 'Not Linked',
    not_present: 'Not present',
    not_seen: 'Not seen',
    not_specified: 'Not specified',
    notificable: 'related',
    notificable_id: 'Notificable id',
    notificable_type: 'Notificable type',
    notification: 'Notification',
    notification_devices: 'Notification devices',
    notification_sms_id: 'Notification SMS id',
    notifications: 'Notifications',
    notifications_sms: 'Notifications SMS',
    notify: 'Notify',
    now: 'Now',
    ntp: 'NTP',
    number: 'Number',
    object: 'Object',
    observations: 'Observations',
    of: 'of',
    offline: 'Offline',
    offline_female: 'Offline',
    offline_male: 'Offline',
    ok: 'OK',
    olt: 'OLT',
    olt_id: 'OLT',
    olt_model: 'OLTs Models',
    olt_stats: 'OLT Stats',
    olts: 'OLTs',
    online: 'Online',
    online_female: 'Online',
    online_male: 'Online',
    online_payment: 'Online payment',
    only_integer: 'Number value only',
    ont: 'ONT',
    ont_authorized_not_linked: 'Authorized not linked',
    ont_not_authorized: 'Unauthorized',
    ont_signal: 'ONT Signal',
    onts: 'ONTs',
    onu: 'ONU',
    onu_contracts_signals: 'ONU Contracts Signals',
    onu_reboot: 'Reboot ONT',
    open_massive_update: 'Open massive update',
    optical_fiber: 'Optical fiber',
    order: 'Order',
    order_configurations: 'Order Configurations',
    order_parameters: 'Order Parameters',
    osis_no_records: 'No networks to show',
    others: 'Others',
    owner: 'Owner',
    pagoralia: 'Pagoralia',
    paid: 'Paid',
    paid_amount: 'Paid amount',
    parameters: 'Parameter',
    password: 'Password',
    pay: 'Pay',
    pay_u: 'PayU',
    pay_with: 'Pay with',
    payment: 'Payment',
    payment_associated_with: 'Payment associated with',
    payment_cancellation: 'Payment cancellation',
    payment_date: 'Payment date',
    payment_details: 'Payment details',
    payment_gateway: 'Payment gateway',
    payment_gateways: 'Payment gateways',
    payment_in_exchange_currency: 'Payment in exchange currency',
    payment_method: 'Payment method',
    payment_methods: 'Payment methods',
    payment_promise: 'Payment promise',
    payment_promises: 'Payment promises',
    payment_receipt: 'Payment receipt',
    payment_transactions: 'Payment transactions',
    payment_way: 'Payment way',
    payments: 'Payments',
    pcq_with_queue_tree: 'PCQ with queue tree',
    pcq_with_simple_queue: 'PCQ with simple queue',
    pending: 'Pending',
    pending_verification_by_support: 'Verificación pendiente por soporte',
    percentage: 'Percentage',
    perform_conversion: 'Perform conversion',
    period: 'Period',
    period_invoiced: 'Period invoiced',
    periods: 'Periods',
    permissions: 'Permissions',
    personal_information: 'Personal information',
    phone: 'Phone',
    phone_mobile: 'Mobile phone',
    phone_number: 'phone_number',
    phones: 'Teléfonos',
    pichincha: 'Pichincha',
    ping: 'Ping',
    plan: 'Plan',
    plan_details: 'Plan Details',
    plan_id: 'Plan (ID)',
    plan_name: 'Plan name',
    plantilla: 'Plantilla',
    pool_numbers: 'Numeration',
    port: 'Port',
    port_disabled: 'Disable port',
    port_enabled: 'Enable port',
    ports: 'Ports',
    ports_redirect_vpn: 'Ports to redirect via VPN',
    power_limit: 'Reference power',
    ppp_profile: 'PPP Profile',
    ppp_profile_id: 'PPP Profile (ID)',
    ppp_profiles: 'PPP Profiles',
    pppoe: 'PPPoE',
    pppoe_enabled: 'PPPoE Enabled',
    pppoe_password: 'PPPoE Password',
    pppoe_server: 'PPPoE Server',
    pppoe_server_name: 'PPPoE Server Name',
    pppoe_status: 'PPPoE Status',
    pppoe_username: 'PPPoE Username',
    prefix: 'Prefix',
    presence: 'Is required',
    present: 'Present',
    preview: 'Preview',
    preview_pool_numbers: 'Preview pool numbers',
    previous: 'Previous',
    price: 'Price',
    price_per_day: 'Price/Days',
    principal_activity: 'Principal Activity',
    print: 'Print',
    print_pos: 'Print (POS)',
    priority: 'Priority',
    prisma: 'Prisma',
    process_transaction_in_wispro: 'Process transaction in Wispro',
    processed: 'Processed',
    processed_at: 'Processed at',
    processing: 'Processing',
    product: 'Product',
    product_code: 'Product Code',
    profile: 'Profile',
    profile_name: 'Profile name',
    profiles: 'Profiles',
    prospect: 'Prospect',
    provider: 'Provider',
    provider_group: 'Provider group',
    //Estas keys se crearon para rails provisoriamente
    province_state_region: 'Province/State/Region',
    public: 'Public',
    public_address: 'Public address',
    public_for_mobile: 'Visible to the mobile application',
    public_ip: 'Public IP',
    publish: 'Publish',
    published: 'Published',
    published_at: 'Published at',
    publishing: 'Publishing',
    push_token: 'Push token',
    qr_enabled: 'Enabled QR',
    quality_service: 'Quality service',
    quantity: 'Quantity',
    quick_search: 'Quick search',
    quick_search_description_tour:
      'Instantly filter your {{model}}, forget about endless scrolling. This new quick search makes your daily queries ultra-fast.',
    radius: 'Radius',
    radius_disabled: 'Radius disabled',
    radius_enabled: 'Radius enabled',
    re_subscribe: 're-subscribe',
    reactivate: 'Reactivate',
    reactivate_account: 'Reactivate Account',
    receiver: 'Receiver',
    reconfig: 'Overwrite configuration',
    reconnection: 'Reconnection',
    reconnection_charge: 'Reconnection charge',
    recurring: 'Recurring',
    recurring_item: 'Recurring Item',
    recurring_items: 'Recurring items',
    reference: 'Reference',
    reference_prefix: 'Reference prefix',
    refresh_errors: 'Refresh errors',
    refund: 'Refund',
    regenerate_password: 'Regenerate password',
    registered_at: 'Registered at',
    registered_vat_payer: 'Registered vat payer',
    rejected_files: 'Rejected files',
    reload: 'Reload',
    reload_form: 'Reload Form',
    reload_page: 'Reload page',
    remote_address: 'Remote Address',
    remove_pack: 'Remove Pack',
    remove_payment_gateway: 'remove paymentGateway',
    remove_selection: 'Remove selection',
    remove_zone: 'Remove zone',
    remove_zones: 'Remove zones',
    rename: 'Rename',
    replace: 'Replace',
    replace_cells_for: 'Replace cells for',
    report_transaction: 'Report transaction',
    request_timeout: 'Request expired due to timeout',
    required: 'Required',
    reset: 'Reset',
    reset_user: 'Reset user',
    restore: 'Restore',
    resubscribe: 'Resubscribe',
    retry: 'Retry',
    retry_connection_with_the_olt: 'Retry connection with the Olt',
    revenue: 'Revenue',
    revenue_share: 'Revenue share',
    rif: 'RIF',
    role: 'Role',
    roles: 'Roles',
    rx_critical: 'Critical',
    rx_optimal: 'Optimal',
    rx_warning: 'Warning',
    sale: 'Sale',
    sale_desk: 'Sale desk',
    sale_desk_read_only: 'Read only Sale desk',
    sale_desk_supervisor: 'Sale desk supervisor',
    sale_desk_supervisor_read_only: 'Read only Sale desk supervisor',
    sale_point: 'Sale point',
    save: 'Save',
    save_active_filters: 'Save active filters',
    saved_filters: 'Saved filters',
    saved_records_list: 'Saved records list',
    scheduled_at: 'Scheduled at',
    seal: 'Seal',
    seal_code: 'Seal code',
    seal_id: 'Seal (ID)',
    search: 'Search',
    search_engine: 'Search engine',
    search_templates: 'Search templates',
    search_transaction: 'Search transaction',
    second_last_name: 'Second last name',
    second_name: 'Second name',
    see: 'See',
    see_client_details: 'See client detail',
    see_credit_note_detail: 'See credit note detail',
    see_invoice_detail: 'See invoice detail',
    see_less: 'See less',
    see_more: 'See more',
    see_payment_detail: 'See payment detail',
    see_token: 'See TOKEN',
    seen: 'Seen',
    select_a_date: 'Select a date',
    select_a_model: 'Select a model',
    select_a_option: 'Select a option',
    select_a_template: 'Select a template',
    // corregir en las vistas
    select_all: 'Select {{number}} {{model}}',
    select_an_option: 'Select an option',
    select_channel_and_template: 'Select Channel and Template',
    select_for_bulkactions: 'Select for bulk actions',
    select_option: 'Select an Option',
    select_template_channel_title: 'Select a template and channel',
    self_assigned_by_olt: 'Self-assigned by OLT',
    self_employed_taxpayer: 'Self employed taxpayer',
    seller: 'Seller',
    seller_id: 'Seller (ID)',
    seller_read_only: 'Read only Seller',
    send_by_email: 'Send by email',
    send_email_when_create_payment: 'Send email when create payment',
    send_email_when_issue_invoices: 'Send email when issue invoice',
    sending: 'Sending',
    sent: 'Sent',
    sent_at: 'Sent at',
    sent_sms: 'Sent SMS',
    sequential_id: '#',
    serial: 'Serial',
    server: 'Server',
    server_acs: 'Server ACS',
    server_configuration_not_linked: 'Server not linked',
    servers: 'servers',
    service: 'Service',
    service_card: 'Service card',
    service_dgo: 'Directv Go Service',
    services: 'Services',
    setn_to: 'Sent to',
    setup_automatic_notifications: 'Setup automatic notifications',
    shipping_details: 'Shipping details',
    show: 'Show',
    show_alerts: 'Show alerts',
    show_all: 'Show All',
    show_contracts: 'Show Contracts',
    show_details: 'Show details',
    show_filters: 'Show filters',
    show_hide_columns: 'Show/Hide Columns',
    show_info: 'Show information',
    show_less: 'Show less',
    show_more: 'Show more',
    show_naps: 'Show NAPs',
    show_preview: 'Show Preview',
    show_seals: 'Show Seals',
    showing: 'Showing',
    showing_all: 'Showing All',
    signal: 'Signal',
    signal_quality: 'Signal quality',
    signature: 'Signature',
    siigo_configuration: 'Siigo conf',
    siigo_credit_note_document_type: 'Credit note voucher',
    siigo_invoice_document_type: 'Invoice voucher type',
    siigo_product: 'Product/Service',
    simple_queue: 'Simple Queue',
    since: 'Since',
    siro: 'Siro',
    six_months: 'Last 6 months of consumption',
    skype: 'Skype',
    sms: 'SMS',
    sms_vendor_id: 'SMS ID',
    social_stratum: 'Social stratum',
    something_went_wrong: 'Opps, An error occurred Try again or contact support',
    sorry_service_unavailable: 'Sorry, service unavailable',
    sort_by: 'Sort by',
    source: 'Source',
    spanish: 'Spanish',
    speed: 'Speed',
    speed_test: 'Speed test',
    ssid: 'SSID',
    start_activities_date: 'Start activities date',
    start_chat: 'Start chat',
    start_date: 'Start date',
    start_invoicing_date: 'Start invoicing date',
    start_invoicing_day: 'Billing cycle begins on the day.',
    started_at: 'Started at',
    state: 'State',
    statistics: 'statistics',
    stats: 'Stats (Graphs)',
    status: 'State',
    strategy: 'Strategy',
    street: 'Street',
    street_number: 'Street number',
    subdomain: 'Subdomain',
    subject: 'Subject',
    submit: 'Submit',
    subscribe: 'Subscribe',
    subscription: 'Subscription',
    subscriptions: 'Subscriptions',
    substitutions: 'Substitutions',
    subtotal: 'Subtotal',
    success: 'Success',
    successful_connection: 'Successful connextion',
    suffix: 'Suffix',
    support: 'Support',
    support_hola_suite_text: 'Hello! We are here to help you. Start chatting with our support team.',
    support_hola_suite_trial_license:
      'Dear customer, online support is only available for active subscriptions.<1></1><2></2>In your case, you should request assistance from your account manager or you can email us at: <4>asistencia-offline@wispro.co</4><5></5><6></6>Thank you very much!',
    support_online: 'Online Support',
    surcharges: 'Surcharges',
    system: 'System',
    tags: 'Tags',
    tax: 'Tax',
    tax_regime: 'Tax Regime',
    tax_responsibility: 'Tax responsibility',
    taxes: 'Taxes',
    taxpayer_identification_number: 'Taxpayer Identification Number',
    technician: 'Technician',
    technician_read_only: 'Read only Technician',
    technician_supervisor: 'Technician supervisor',
    technician_supervisor_read_only: 'Read only Technician supervisor',
    telegram: 'Telegram',
    telegram_quantity: 'Telegram quantity',
    terms_and_conditions: 'Terms and Conditions',
    the_acs_service_is_disabled: 'The ACS service is disabled',
    the_acs_service_is_enabled: 'The ACS service is enabled',
    the_nas_service_is_disabled: 'The NAS service is disabled',
    the_nas_service_is_enabled: 'The NAS service is enabled',
    the_number_of_linked_nas_is_counted: 'The number of linked nas is counted',
    the_radius_service_is_disabled: 'The radius service is disabled',
    the_radius_service_is_enabled: 'The radius service is enabled',
    this_device_does_not_support_wi_fi_configuration: "This device doesn't support wi-fi configuration",
    three_months: 'Last 3 months of consumption',
    ticket: 'Ticket',
    ticket_id: 'Ticket ID',
    ticket_lost: 'Ticket lost',
    ticket_number: 'Ticket number',
    tickets: 'Tickets',
    time_zone: 'Time zone',
    title: 'Title',
    to_be_invoiced: 'To be invoice',
    to_create_the_contract: 'To create the contract, click here',
    to_disable: 'Disable',
    to_enable: 'Enable',
    to_reschedule: 'To reschedule',
    to_send: 'To sent',
    today: 'Today',
    tolerance: 'Tolerance',
    total: 'Total',
    total_amount: 'Total amount',
    total_items: 'Total items',
    total_lapses: 'Total lapses',
    total_nas_linked: 'Total NAS linked',
    total_records: 'Total records',
    total_to_avoid: ' Total to avoid',
    trace_route: 'Traceroute',
    traffic: 'Traffic',
    traffic_control: 'Traffic control',
    transaction: 'Transaction',
    transaction_already_exist: 'Transaction already exists',
    transaction_amount: 'Transaction amount',
    transaction_code: 'Transaction code',
    transaction_details: 'Transaction_details',
    transaction_number: 'Transaction number',
    transaction_value: 'Transaction value',
    transactions: 'Transactions',
    transation_id: 'Transaction ID',
    transmitting_data: 'Transmitting data',
    trial_due: 'Trial due',
    trial_duration: 'Trial duration',
    trial_expiration_date: 'Trial expiration date',
    trial_used: 'Trial used',
    trialing: 'Trialing',
    try_again: 'Try again',
    try_again_or_contact_support: 'Try again or contact support',
    type: 'Type',
    unauthorize: 'Unauthorize',
    unauthorized: 'Unauthorized',
    unexpected_error_getting_data: 'Unexpected error getting {{model}}',
    unidentified: 'Unidentified',
    unique_transaction_code: 'Unique transaction code',
    unit: 'Unity',
    unit_price: 'Unit price',
    unknown: 'Unknown',
    unlock: 'Unlock',
    unpaid: 'Unpaid',
    unpaid_bills: 'Unpaid bills',
    unpaid_invoices: 'Unpaid Invoices',
    unsubscribe: 'Unsubscribe',
    unsubscribe_subscription: 'Unsubscribe subscription',
    until: 'Until',
    unverified: 'Unverified',
    unviewed: 'Unviewed',
    up_to_date: 'Up to date',
    update: 'Update',
    update_certificate: 'Update certificate',
    update_date: 'Update date',
    update_payments_gateway: 'Update payments gateway',
    updated_at: 'Updated at',
    upload_afip_certificate: 'Upload the certificate issued by AFIP',
    uploading: 'Uploading',
    uploading_file: 'Uploading file',
    use_contract_form: 'Use contract form',
    use_wispro_sstp: 'Use Wispro VPN',
    user: 'User',
    user_id: 'User (ID)',
    user_locked: 'User locked',
    user_responsible: 'User Responsible',
    username: 'Username',
    users: 'Users',
    uzera: 'Uzera',
    validate_data: 'Validate data',
    vat_condition: 'Vat Condition',
    verified: 'Verified',
    verified_by_support: 'Verified by support',
    verified_client: 'Verified client',
    verify: 'Verify',
    verify_by_support: 'Verify by support',
    verify_file: 'Verify file',
    verify_webservice_connection: 'Verify webservice connection',
    verifying: 'Verifying',
    version: 'Version',
    view_billing_transactions: 'View billing transactions',
    view_client: 'view Client',
    view_details: 'View details',
    view_invoice_details: 'View invoice details',
    view_link: 'View link',
    view_new_changes: 'Explore changes',
    viewed: 'Viewed',
    vippo: 'ViPPO',
    virtual_agent: 'Virtual Agent',
    vlan: 'VLAN',
    void: 'Void',
    voided: 'Voided',
    voucher: 'Voucher',
    wan_configuration: 'WAN configuration',
    warning: 'Warning',
    watch_video: 'Watch video',
    web_port: 'Web Port',
    webservice_info: 'Webservice information',
    week: 'Week',
    week_control: 'Week control',
    whatsapp: 'Whatsapp',
    where: 'Where',
    wifi: 'Wi-Fi',
    wifi_configuration: 'Wi-Fi configuration',
    will_deleted_one: 'Will deleted',
    will_deleted_other: 'Will deleted',
    will_unlink_plural: 'Will unlink',
    will_unlink_singular: 'Will unlink',
    will_update_verb: 'Will update',
    will_updates_verb: 'Will updates',
    winbox_port: 'Winbox Port',
    wispbot_initial_message: 'Hi I want to ask you a question',
    wispro_automatically: 'Wispro (Automatically)',
    wispro_automatically_unaccent: 'Wispro (Automatically)',
    wispro_box: 'WisproBox',
    wispro_cloud: 'Wispro cloud',
    wispro_migration: 'Wispro migration',
    wispro_system: 'Wispro (system)',
    with: 'With',
    with_payment_gateways: 'With payment gateways',
    without: 'Without',
    without_changes: 'Sin cambios',
    without_neighborhoods: 'Without Neighborhoods',
    without_payment_gateways: ' Without payment gateways',
    without_permissions: 'Without permissions',
    without_taxpayer_identification_number: 'Wihtout taxpayer identification number',
    without_zones: 'Without Zones',
    wompi: 'Wompi',
    write_comment: 'Write comment...',
    year: 'Year',
    years: 'Years',
    yes: 'Yes',
    you_can_search_by: 'You can search by',
    zip_code: 'Zip Code',
    zone: 'Zone',
    zones: 'Zones',
    zoom_in: 'Zoom in',
    zoom_out: 'Zoom out'
  }
};
